import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
// internal components
import "./style.scss";

import NormalButton from "../../../common/NormalButton/NormalButton";
import Title from "../../../common/title";
// services
import { } from "react-router-dom";

import {
  coOperativeSociety,
  history,
  HUF,
  parterAndLLP,
  proprietory,
  publicAndPrivate,
} from "helpers";
import { useForm } from "react-hook-form";

import { Tooltip } from "antd";
import CustomController from "component/common/Controller";
import FormErrorMessage from "component/common/ErrorMessage";
import FileUpload from "component/common/FileUpload";
import UploadFile from "component/common/FileUpload/UploadFile";
import MsmeDeclarationModal from "component/common/MsMeDeclaration/MsmeDeclaration";
import { BsInfoCircle } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import {
  fileUpload,
  ReuploadAddtionalDocument,
  uploadAddtionalDocument,
} from "service/customer";
import { Toast } from "service/toast";

const UploadAdditionalForm = forwardRef(
  (
    {
      submitreq = false,
      ResponseData,
      setonsubmitfun,
      entiredata,
      entityName = "",
    },
    ref
  ) => {
    const {
      register,
      handleSubmit,
      getValues,
      formState: { errors },
      setValue,
      reset,
      control,
    } = useForm({
      mode: "all",
    });

    const [documents, setDocuments] = useState([]);
    const [documentsnotification, setDocumentsnotification] = useState([]);
    const [documentData, setDocumentData] = useState([]);
    const [requiredDoc, setRequiredDoc] = useState([]);
    const [entity, setEntity] = useState("");
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [Notificationdocument, setNotificationdocument] = useState();
    const [contractid, setcontractid] = useState();
    const [newDocuments, setNewDocuments] = useState([]);
    const [msmemodal, setmsmemodal] = useState(false);
    const [MSMEregistration, setMSMEregistration] = useState({});
    const [MSMEregistrationview, setMSMEregistrationview] = useState(true);
    const [entireList, setEntireList] = useState([]);
    const location = useLocation();
    
    useEffect(() => {
      if (submitreq) {
        setonsubmitfun(true);
        setDocuments(ResponseData?.state?.document_isSubmitRequest);
        setEntity(ResponseData?.state?.entity_isSubmitRequest);
        setcontractid(ResponseData?.state?.contractid_isSubmitRequest);
      } else {
        setDocuments(location?.state?.documents);
        setEntity(location?.state?.entity);
        setDocumentsnotification(
          location?.state?.notifcation?.extra?.documents
        );
        setEntireList(location?.state?.entireData);
      }
    }, []);

    useImperativeHandle(ref, () => ({
      onSubmit,
    }));
    const notifcation = location?.state?.notifcation?.extra?.documents;

    const notificationnewArray = notifcation?.filter(
      (x) => x?.status === "REJECTED" || x?.status === "CORRECTION REQUIRED"
    );

    let incomingData = [];
    const newArray = documents?.filter((x) => x?.documentId === null);
    incomingData = newArray;
    useEffect(() => {
      let uploadedData = [];
      if (entity === "Public Ltd") {
        uploadedData = publicAndPrivate;
      } else if (entity === "Pvt Ltd") {
        uploadedData = publicAndPrivate;
      } else if (entity === "Proprietor") {
        uploadedData = proprietory;
      } else if (entity === "Partnership") {
        uploadedData = parterAndLLP;
      } else if (entity === "LLP") {
        uploadedData = parterAndLLP;
      } else if (entity === "HUF") {
        uploadedData = HUF;
      } else if (entity === "Cooperative/FPO/FPC") {
        uploadedData = coOperativeSociety;
      }
      // else if (entity === "Cooperative") {
      //   uploadedData = coOperativeSociety;
      // }else if (entity === "FPO/FPC") {
      //   uploadedData = coOperativeSociety;
      // }
      setDocumentData(uploadedData);
    }, [entity]);
    useEffect(() => {
      const newDocumentFetch = documentData?.filter((item) =>
        incomingData?.some((docItem) => docItem.type === item.type)
      );
      if (newDocumentFetch.length > 0) setNewDocuments(newDocumentFetch);
    }, [documentData]);

    
    
    const handleMsmeUpdload = async (name) => {
      
      setMSMEregistration(name);
      const type = "MSME Declaration";
      let fileLimit = 1;
      try {
        let existing = newDocuments.filter((item) => item.typeName === type);
        let existingIndex = newDocuments.findIndex(
          (item) => item.typeName === type
        );
        if (existing.length <= fileLimit) {
          let updatedDocId = [...newDocuments];
          updatedDocId[existingIndex] = {
            ...updatedDocId[existingIndex],
            documentId: Number(name?.documentId),
            fileName: [name?.fileName],
            limit: fileLimit,
            typeName: type,
            required: false,
          };
          setNewDocuments(updatedDocId);
        } else {
          let updatedDocId = [...newDocuments];
          updatedDocId[existingIndex] = {
            ...updatedDocId[existingIndex],
            documentId: Number(name?.documentId),
            fileName: [name?.fileName],
            limit: fileLimit,
            typeName: type,
            required: false,
          };
          setNewDocuments(updatedDocId);
        }
      } catch (e) {
        console.log("e :>> ", e);
      }
    };

    const handlefileUpload = async (file, name) => {
      let type = name?.type;
      let fileLimit = name?.limit;
      let typeName = name?.typeName;

      let isRequired = name?.required;
      try {
        let body = new FormData();
        body.append("data", file);
        let response = await fileUpload(body);
        if (response.status === 200) {
          let data = response?.data?.data?.data;
          let existing = newDocuments.filter((item) => item.type === type);
          let existingIndex = newDocuments.findIndex(
            (item) => item.type === type
          );
          if (existing.length <= fileLimit) {
            let updatedDocId = [...newDocuments];
            updatedDocId[existingIndex] = {
              ...updatedDocId[existingIndex],
              documentId: Number(data?.documentId),
              fileName: [data?.fileName],
              limit: fileLimit,
              typeName: typeName,
            };
            setNewDocuments(updatedDocId);
          } else {
            let updatedDocId = [...newDocuments];
            updatedDocId[existingIndex] = {
              ...updatedDocId[existingIndex],
              documentId: Number(data?.documentId),
              fileName: [data?.fileName],
              limit: fileLimit,
              typeName: typeName,
            };
            setNewDocuments(updatedDocId);
          }
        }else{
          Toast({type : "error", message:response?.data?.message})
        }
      } catch (e) {
        console.log("e :>> ", e);
      }
    };


    const handlefileREUpload = async (file, name) => {
      let type = name?.type;
      let isRequired = name?.required;
      let typeName = name?.typeName;
      try {
        let body = new FormData();
        body.append("data", file);
        let response = await fileUpload(body);
        if (response.status === 200) {
          let data = response?.data?.data?.data;
          let documentId = data?.documentId;
          let updatedDocId = [...requiredDoc];
          updatedDocId.push({
            type: type,
            documentId: Number(documentId),
            isRequired: isRequired,
            typeName: typeName,
          });
          setRequiredDoc(updatedDocId);
        }else{
          Toast({type : "error", message:response?.data?.message})
        }
      } catch (e) {
        console.log("e :>> ", e);
      }
    };
    const handleDeleteDocument = (id) => {
      const filterDoc = requiredDoc.filter(x => x.type !== id)

      setRequiredDoc(filterDoc)
    }


    const onSubmit = async () => {
      const recuredDocMap = {};
      requiredDoc.forEach((item) => {
        recuredDocMap[item.type] = item;
      });

      const updatedIncomingData = documents.map((item) => {
        const recuredItem = recuredDocMap[item.type];
        if (recuredItem) {
          return {
            ...item,
            documentId: recuredItem.documentId,
          };
        }
        return item;
      });

      const newDocs = documents?.filter((item) => item?.documentId !== null);
      const updatedVerifiedDocs = updatedIncomingData?.filter(
        (item) => item?.documentId == null
      );
      const mergedDocs = [...updatedVerifiedDocs, ...newDocs];
      const filteredDocId = documents.filter((x) => x.documentId !== null);
      const filnalValue = filteredDocId.concat(newDocuments);
      try {
        const body = {
          documents: filnalValue,
        };

        const contractIdToUse = submitreq
          ? contractid
          : location?.state?.contractId;

        const response = await uploadAddtionalDocument(body, contractIdToUse);
        if (response.status === 200) {
          Toast({ type: "success", message: response.data.message });
          history.push("/admin/dashboard");
        } else {
          Toast({ type: "error", message: response.data.message });
        }
      } catch (e) {
        console.log("e", e);
      }
    };

    const NotificationonSubmit = async () => {
      const recuredDocMap = {};
      requiredDoc.forEach((item) => {
        recuredDocMap[item.type] = item;
      });

      const updatedIncomingData = documentsnotification.map((item) => {
        const recuredItem = recuredDocMap[item.type];
        if (recuredItem) {
          return {
            // ...item,
            documentId: recuredItem.documentId,
            status: "PENDING",
            type: recuredItem?.type,
          };
        }
        return item;
      });

      try {
        const body = {
          documents: updatedIncomingData,
        };
        // return;
        const response = await ReuploadAddtionalDocument(
          body,
          location?.state?.notifcation?.extra?.contractId,
          location?.state?.notifcation?.notificationId
        );
        if (response.status === 200) {
          Toast({ type: "success", message: response.data.message });
          history.push("/admin/dashboard");
          // window.location.reload();
        } else {
          Toast({ type: "error", message: response.data.message });
        }
      } catch (e) {
        console.log("e", e);
      }
    };

    const handledocumentID = async (fileName, index, documentID) => {
      let existingIndex = newDocuments.findIndex(
        (item) => item.type === documentID?.type
      );
      let updatedDocId = [...newDocuments];
      updatedDocId[existingIndex] = {
        ...updatedDocId[existingIndex],
        documentId: null,
        fileName: null,
      };
      setNewDocuments(updatedDocId);
    };

     const handleMsmeModel = () => {
        if (Boolean(entityName)) {
          setmsmemodal(true);
        } else {
          Toast({
            type: "error",
            message: "Enter Name Of Entity",
          });
        }
      };

    
    return (
      <div>
        <div className="mb-1">
          <Title title={submitreq ? "" : "Upload Additional Documents"} />
        </div>
        <form className="mt-md-5">
          <div className="basic-form px-2 py-md-2 ">
            <div className="row align-items-center py-md-2">
              {notifcation ? (
                <>
                  {notificationnewArray?.map((document, index) => {
                    const uploadedFile = uploadedFiles[document.name];
                    return (
                      <div
                        className={"col-12 my-3 d-flex flex-md-row flex-column align-items-end  pt-auto pb-0"}
                        key={index}
                      >
                        <div className="d-flex flex-column col-md-4 col-12 addi_text">

                          <label className="fw-bold mb-3 mt-1 ">
                            {document?.status == "REJECTED"
                              ? "Rejected Reason"
                              : "Reason for Correction"}{" "}
                            : {document?.reason}
                          </label>

                          {document.type}
                        </div>
                        <br />
                        <div className="col-md-4 col-12 d-flex flex-column">
                          <FileUpload
                            handleFile={(file) => {
                              handlefileREUpload(file, document);
                              setUploadedFiles((prevState) => ({
                                ...prevState,
                                [document.name]: file,
                              }));
                            }}
                            name={document?.name}
                            documentID={document.type}
                            errors={errors}
                            register={register(document?.name, {
                              required: document.isRequired
                                ? !uploadedFile
                                : false,
                            })}
                            handledocumentID={handleDeleteDocument}
                          />
                          {document.required && !uploadedFile && (
                            <FormErrorMessage
                              error={errors?.[document?.name]}
                              messages={{
                                required: `${document?.name} is Required`,
                              }}
                            />
                          )}
                        </div>

                      </div>
                    );
                  })}

                  <div className="px-md-5 py-md-5 py-2">
                    <div className="row align-items-center">
                      <div className="col-0 col-md-7"></div>
                      <div className="col-12 col-md-5">
                        <div className="row justify-content-end">
                          <div className="col-md-6 col-4">
                            <NormalButton
                              className="loginOutline text-uppercase"
                              label={"Cancel"}
                              onClick={() => history.push("/admin/dashboard")}
                            />
                          </div>
                          <div className="col-md-6 col-4">
                            <NormalButton
                              className="orderBtn text-uppercase"
                              label={"Submit"}
                              onClick={handleSubmit(NotificationonSubmit)}
                              disabled={requiredDoc?.length !== notificationnewArray.length}
                            />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className={!submitreq ? "row ms-0 ms-md-4  py-2" : "row"}>
                  {newDocuments?.map((document, index) => {
                    const isRequired = () => {
                      if (document?.required) {
                        if (
                          Array.isArray(document?.documentId) &&
                          document?.documentId.every((id) => id === null)
                        ) {
                          return true;
                        } else if (!document?.documentId) {
                          return true;
                        }
                      }
                      return false;
                    };

                    const uploadedFile = uploadedFiles[document.name];
                    return (
                      <div
                        className={"col-12 my-3 d-flex flex-md-row flex-column align-items-start  pt-auto pb-0"}
                        key={index}
                      >
                        <label className="col-md-4 col-12 d-flex flex-column">
                          <div className="d-flex pe-4" >
                            <p className="m-0 w-auto">

                              {document?.type}
                            </p>
                          </div>
                          &emsp;
                          {document.documentId == null &&
                            document?.name == "MSME Registeration" ? (
                            <div>
                              <span
                                className="text-primary   m-0"
                                style={{
                                  fontSize: "12px",
                                  textDecoration: "underline",
                                  fontWeight: 150,
                                }}
                                onClick={() => {
                                  if (submitreq) {
                                    if (Boolean(entityName)) {
                                      setmsmemodal(true);
                                    } else {
                                      Toast({
                                        type: "error",
                                        message: "Enter Pan Name ",
                                      });
                                    }
                                  } else {
                                    setmsmemodal(true);
                                  }
                                }}
                              >
                                View MSME Registration
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </label>
                        <div className="col-md-8 col-12 d-flex flex-column mt-2 mt-md-0">

                          <CustomController
                            name={document?.name}
                            control={control}
                            error={errors?.[document?.name]}
                            rules={{
                              required: isRequired(),
                            }}
                            messages={{
                              required: `${document?.name} is Required`,
                            }}
                            render={({ field: { onChange }, ...fields }) => {
                              return (
                                <UploadFile
                                  {...fields}
                                  handleFile={(file) => {
                                    onChange(file);
                                    handlefileUpload(file, document);
                                    setUploadedFiles((prevState) => ({
                                      ...prevState,
                                      [document?.name]: file,
                                    }));
                                  }}
                                  filelimit={document?.limit}
                                  handleMsme={(x) => handleMsmeModel(x)}
                                 isMsme={document?.typeName === "MSME Declaration"}
                                  entity={entity}
                                  getFileName={document?.fileName || null}
                                  handledocumentID={(
                                    fileName,
                                    index,
                                    documentID
                                  ) => {
                                    handledocumentID(fileName, index, documentID);
                                    // setPanDeleted(true);
                                  }}
                                  documentID={document}
                                  accept={document?.accept}
                                  btnLabel={
                                    (document?.limit !== undefined &&
                                      document?.fileName?.length > 0 &&
                                      document.fileName.every(fileName => typeof fileName === 'string' && fileName.trim() !== '')
                                    )
                                      ? (1 === document.fileName.length ? "Uploaded" : "Upload file")
                                      : "Upload file"
                                  }

                                />
                              );
                            }}
                          />
                          {document?.name == "MSME Registeration" && (
                            <span
                              className="d-block col-12 col-md-6 pt-0 pt-md-2"
                              style={{
                                color: "#4676bf",
                                fontSize: "12px ",
                                // paddingTop: "15px",
                              }}
                            >
                              {" "}
                              <BsInfoCircle /> This file is autogenerated by
                              system based the on the acceptance by user
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {submitreq ? (
                    ""
                  ) : (
                    <div className="px-2 px-md-5 py-0 py-md-5">
                      <div className="row align-items-center">
                        <div className="col-0 col-md-7"></div>
                        <div className="col-12 col-md-5">
                          <div className="row">
                            <div className="col-6">
                              {" "}
                              <NormalButton
                                className="loginOutline text-uppercase"
                                label={"Cancel"}
                                onClick={() => history.push("/admin/dashboard")}
                              />
                            </div>
                            <div className="col-6">
                              {" "}
                              <NormalButton
                                className="orderBtn text-uppercase"
                                label={"Submit"}
                                onClick={handleSubmit(onSubmit)}
                              // disabled={requiredDoc?.length === 0}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <MsmeDeclarationModal
              name={!submitreq ? entireList?.nameOfEntity : entityName}
              isopen={msmemodal}
              onCancel={() => setmsmemodal(false)}
              setMSMEregistration={handleMsmeUpdload}
              setmsmemodal={setmsmemodal}
              // setFilesId={setFilesId}
              setMSMEregistrationview={setMSMEregistrationview}
              MSMEregistrationview={MSMEregistrationview}
            />
          </div>
        </form>
      </div>
    );
  }
);

export default UploadAdditionalForm;
